import {useState, useEffect, useRef} from 'react';
import { useSearchParams } from 'react-router-dom';
import { getRequest } from '../../../global/utils/apiCall';
import PaginationComponent from '../../../global/Components/Pagination/PaginationComponent';
import ProductCommentSection from '../../../global/Components/Tab/TabContent/Sections/ProductCommentSection';
import { Spinner } from 'reactstrap';
import { Toast } from 'primereact/toast';

const USER_COMMENTS_URL = 'api/v1/comments/vendor/list';

export default function LastQuestion({userId}) {
    // const [searchParams, setSearchParams] = useSearchParams();
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [comments, setComments] = useState([]);
    const [metaDataComments, setMetaDataComments] = useState();
    const [currentPageComments, setCurrentPageComments] = useState();

    const showSuccess = (message) => {
      toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const callUserComments = async () => {
      setIsLoading(true);
  
      try {
        const response = await getRequest(USER_COMMENTS_URL,{
          params: {
            user_id: userId,
            limit: 10,
            page: currentPageComments && currentPageComments,
          }
        });
        setComments(response.data.data);
        setMetaDataComments(response.data.meta);
        setCurrentPageComments(response.data.meta?.current_page);
        setIsLoading(false);

      }
      catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message);
      }  
        setIsLoading(false);
      }
      finally {
        setIsLoading(false);
      }
      }

      useEffect(() => {
        callUserComments();
      },[]);
    
      useEffect(() => {
        // currentPageComments &&
        //   searchParams.set('c-page', currentPageComments);
        //   setSearchParams(searchParams);
          callUserComments();
      },[currentPageComments]);
  return (
    <>
      <Toast ref={toast} position="top-center" />

        {isLoading
            ? <div className='text-center'>
                <Spinner color='primary' className='mx-auto'>
                    Loading...
                </Spinner>
            </div>
            : comments.length > 0 
                ? (
                    <div>
                        {
                            comments.map((item) => (
                                <ProductCommentSection key={item.id} data={item}></ProductCommentSection>
                            ))
                        }
                            <PaginationComponent  currentPage={currentPageComments} setCurrentPage={setCurrentPageComments}  metaData={metaDataComments} />
                    </div>
                )
                : (
                    <p className="fw-bold py-4">No Questions to display</p>

                )
        }
    </>
  )
}
